import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { ICheckboxProps } from './index'

type C = React.ComponentType<ICheckboxProps>

function withRedux(Component: C) {
  function doNothing() {
    return
  }

  return function({
    input,
    meta,
    ...rest
  }: WrappedFieldProps & ICheckboxProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onClick={doNothing}
        onChange={input.onChange}
        onFocus={input.onFocus}
        // onBlur={input.onBlur}
        errorMsg={meta.touched && meta.error}
        warningMsg={meta.touched && meta.warning}
        {...rest}
      />
    )
  }
}

export default withRedux
